module.exports = __webpack_public_path__ + "img/truck-user1.1f7beca5.jpg";